<template>
  <el-dialog :close-on-click-modal="false" :show="show" :visible="visible" title="港口信息维护"
             width="20%"
             @close="close" custom-class="module-dialog">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="detail-form-content" label-width="120px">
      <el-form-item class="input" label="港口信息" prop="portName">
        <!--                <el-input v-model="ruleForm.portName" autocomplete="off" placeholder="港口名称" />-->
        <el-select v-model="ruleForm.portName" placeholder="请选择港口" style="width:80%">
          <el-option v-for="item in portList" :label="item.indexName" :value="item.indexName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="港杂费" prop="portPrice">
        <el-input v-model="ruleForm.portPrice" autocomplete="off" placeholder="港杂费" @change="getPrice"/>
      </el-form-item>
      <el-form-item label="不含税港杂费" prop="bhsPortPrice">
        <el-input v-model="ruleForm.bhsPortPrice" autocomplete="off" placeholder="不含税港杂费" readonly/>
      </el-form-item>
      <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
        <el-button v-show="updateBtn" class="btn" type="primary" @click="commit()">保存</el-button>
        <el-button class="btn close" @click="close()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import base from '../../../utils/base'

export default {
  name: 'addOrUpdate',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    show() {
      this.visible = this.show;
      if (this.show) {
        window.vm = this;
        this.initPortList();
        this.getBaseCocalConfig();
      }
    },
    rowData() {
      this.ruleForm = this.rowData;
      if (this.rowData.type === 'info') {
        this.updateBtn = false;
      }
    },
  },
  data() {
    return {
      updateBtn: true,
      url: base.get().url,
      visible: false,
      ruleForm: {
        portName: '',
        portPrice: '',
        bhsPortPrice: '',
      },
      rules: {
        portName: [{required: true, message: '请输入港口名称', trigger: 'blur'}],
        portPrice: [{required: true, message: '请输入港杂费', trigger: 'blur'}],
      },
      portList: [],
      baseCocalConfig: {},
    }
  },
  methods: {
    getBaseCocalConfig() {
      this.$http({
        url: "baseCocalConfig/list",
        method: "get",
      }).then(({data}) => {
        let arr = data.data;
        if (arr.length > 0) {
          this.baseCocalConfig = arr[0];
        }
      });
    },
    getPrice() {
      if (this.ruleForm.portPrice === '' || this.ruleForm.portPrice === undefined) {
        this.ruleForm.bhsPortPrice = '';
        return;
      }
      console.log(this.baseCocalConfig);
      this.ruleForm.bhsPortPrice = (this.ruleForm.portPrice / this.baseCocalConfig.gzTaxPoint).toFixed(2);
    },
    close() {
      this.updateBtn = true;
      this.$refs['ruleForm'].resetFields();
      this.$emit("listenToChildEvent", false);
    },
    commit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.ruleForm.id == '' || this.ruleForm.id == undefined ? this.url + `port/` + "save" : this.url + `port/` + "update",
            method: "post",
            data: this.ruleForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.close();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    initPortList() {
      let params = {
        page: 1,
        limit: 200,
        sort: 'id',
      }
      //本表的
      params['dicCode'] = "port_name"//编码名字
      params['dicName'] = "港口名称",//汉字名字
          this.$http({
            url: "dictionary/page",
            method: "get",
            params: params
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.portList = data.data.list;
            }
          });
    }


  }
}
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>